import React from 'react'
import { Redirect, Route, Switch } from 'react-router-dom'

import InvoicesList from './InvoicesList'

export default function Invoices() {
	return (
		<React.Fragment>
			<Switch>
				<Route exact path="/invoices" component={InvoicesList} />
				
				<Redirect to="/404" />
			</Switch>
		</React.Fragment>
	)
}